import React from 'react';
import {getUserAgentData} from 'app/helpers/helpers';
import {DMHint} from 'app/components/banner/DMHint';
import {APPLE_APP_STORE_URL} from 'app/components/banner/notificationVars';
import {useSelector} from 'react-redux';
import {selectCurrentUser} from 'app/hooks/reduxCreateSelectorHooks';
import {useNative} from 'app/contexts/NativeContext';

const DMHintNotSupported = () => {
  const {platform} = getUserAgentData();
  const {notificationPermission} = useSelector(selectCurrentUser);
  const {isFlutter} = useNative();

  if (isFlutter && notificationPermission === 'unsupported') {
    const nativeUnsupportedText = 'Dein aktuelles Gerät unterstützt keine Benachrichtigungen.';
    return <DMHint text={nativeUnsupportedText} action={null} />;
  }

  if (platform === 'iOS') {
    const handleClick = () => {
      window.open(APPLE_APP_STORE_URL, '_blank');
    };
    const iOsHintText =
      'Benachrichtigungen für das aktuelle Gerät werden nicht unterstützt. Installiere die App aus dem App-Store, um Push-Benachrichtigungen zu erhalten.';
    return <DMHint text={iOsHintText} action={{label: 'App Store öffnen', action: handleClick}} />;
  }

  return (
    <DMHint
      text='Dein Browser unterstützt keine Push-Benachrichtigungen. Installiere einen unterstützten Browser, wie Google Chrome oder Firefox.'
      action={null}
    />
  );
};

export {DMHintNotSupported};
